import {
  Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, Renderer2, forwardRef, ViewContainerRef
} from '@angular/core';
import {BASE_COMPONENT, WizBaseComponent} from '../../../core/wiz-base-component';
import { WizTextInput } from '../wiz-text-input/wiz-text-input';
import { IWIZ_COMPONENT} from '../../../../interfaces/iwiz-component';

@Component({
  selector: 'wiz-text-area',
  templateUrl: './wiz-text-area.html',
  styleUrls: ['./wiz-text-area.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: BASE_COMPONENT, useExisting: forwardRef(() => WizTextarea)},
    {provide: WizBaseComponent, useExisting: forwardRef(() => WizTextarea)},
    {provide: IWIZ_COMPONENT, useExisting: forwardRef(() => WizTextarea)}
  ]
})
export class WizTextarea extends WizTextInput {

  constructor(protected cdref: ChangeDetectorRef, public elementRef: ElementRef, public  renderer: Renderer2) {
    super(cdref, elementRef, renderer);
  }

  @Input() // compteur de caractères dans le hint
  public set wizShowLengthHint(v: boolean) {
    this.setWizShowLengthHint(v);
  }
  public get wizShowLengthHint(): boolean {
    return this.getWizShowLengthHint();
  }
  private _wizShowLengthHint: boolean = false;
  /**
   * methodes getter/setter surchargeables du WizShowLengthHint
   */
  protected setWizShowLengthHint(value: boolean) {
    this._wizShowLengthHint = value;
    this.cdref.markForCheck();
  }
  protected getWizShowLengthHint(): boolean {
    return this._wizShowLengthHint;
  }

  // ####
  // ####
  // #### mécanique interne ####
  // ####
  // ####

  /** Returns the text length hint */
  public getLengthHint(): string {
    let result = null;
    if (this.wizShowLengthHint) {
      const count: number = this.innerInputValue ? this.innerInputValue.length : 0;
      result = count.toString();
      if (this.wizMaxlength) {
        result += '/ ' + this.wizMaxlength;
      }
    }
    return result;
  }

  /** override pour gestion éventuelle de la taille de hint */
  public setWizValue(value: any): void {
    if(this.wizShowLengthHint) {
      this.wizHint = this.getLengthHint();
      // TODO MDI : sur chgt valeur, defaut d'affichage dans la mesure
    }
    super.setWizValue(value);
  }

  /**
   * Prise de focus, pour surcharge
   * @param event Evenement focus
   */
  public onFocus(event: FocusEvent): void {
    if (!this._componentIsActive) {// annulée sur onBlur
      this._componentIsActive = true;
      this._wizInitialValue = this.getWizValue();
    }
    this.wizGetFocus();
  }

  /**
   * Perte de focus, pour surcharge
   * @param event Evenement blur
   */
  public onBlur(event: FocusEvent): void {
    this._wizInitialValue = null;
    this._componentIsActive = false;
    this.wizLoseFocus();
  }


  /**
   * override pour gestion éventuelle de la taille de hint
   * @param value, chaine de caractère saisie
   */
  public onChange(value: string){
    if(this.wizShowLengthHint) {
      this.wizHint = this.getLengthHint();
    }
    super.onChange(value);
  }

}
